import { createResponse } from '../response'
import { isNullOrUndefined } from '@/utils/comparators'

const normalizeStatisticsResponse = (data) => {
  let res = {}
  data.calledCountries.forEach(function (item) {
    item.id = item.countryId
  })
  res.calledCountries = createResponse(data.calledCountries)

  if (data.payment) {
    res.paymentCount = data.payment.count
    res.firstPaymentDate = data.payment.first
    res.lastPaymentDate = data.payment.last
  } else {
    res.paymentCount = 0
    res.firstPaymentDate = null
    res.lastPaymentDate = null
  }

  if (data.call) {
    res.callCount = data.call.count
    res.firstCallDate = data.call.first
    res.lastCallDate = data.call.last
  } else {
    res.callCount = 0
    res.firstCallDate = null
    res.lastCallDate = null
  }

  return res
}

const normalizeBehaviorResponse = (data) => {
  let res = {}
  res.hasApp = data.hasApp
  res.hasBoughtDeal = data.hasBoughtDeal
  res.hasLocalNumber = data.hasLocalNumber
  res.hasRebtelCredit = data.hasRebtelCredit
  res.hasRecharge = data.hasRecargas
  res.inRebtelCountry = data.inRebtelCountry
  res.hasSim = data.hasSim
  // todo: remove when isActivist property is deployed to production in proxy api
  if (isNullOrUndefined(data.isActivist)) {
    res.isActivist = false
  } else {
    res.isActivist = data.isActivist
  }

  return res
}

const createUserUpdatePayload = (data) => {
  let payload = {
    'id': data.id,
    'firstName': data.firstName,
    'lastName': data.lastName,
    'email': data.email,
    'displayCurrency': data.currency,
    'locale': data.locale,
    'timezone': data.timezone,
    'countryId': data.countryId,
    'vatNumber': data.vatNumber
  }
  let filtered = {}
  Object.keys(payload).forEach((key) => {
    if (!isNullOrUndefined(payload[key])) {
      filtered[key] = payload[key]
    }
  })
  return filtered
}

export {
  normalizeStatisticsResponse,
  normalizeBehaviorResponse,
  createUserUpdatePayload
}



// WEBPACK FOOTER //
// ./src/api/proxy/normalize.js